import request from './request';

export function vote(data) {
  return request('post', `/apiv2/user-votes/vote`, data);
}

export function voteComment(data) {
  return request('post', `/apiv2/user-votes/update`, data);
}

export function endorsesComment(id, data) {
  return request('get', `/apiv2/crowdpac/${id}/endorses-comment`, data);
}

export function endorses(id, data) {
  return request('get', `/apiv2/crowdpac/${id}/endorses`, data);
}

export function endorsesCandidate(id, data) {
  return request('get', `/apiv2/candidate/${id}/endorses`, data);
}
